import React from "react";
import { cn } from "@gettactic/helpers";

export interface WizardReviewItemProps {
  label: string;
  value: React.ReactNode;
  className?: string;
  emptyText?: string;
}

/** A label and its value on one line of a review step. */
export const WizardReviewItem: React.FC<WizardReviewItemProps> = ({
  label,
  value,
  className,
  emptyText = "—"
}) => (
  <div className={cn("flex justify-between text-sm", className)}>
    <span className="text-content">{label}</span>
    <span className="font-medium text-neutral-900">{value || emptyText}</span>
  </div>
);
